import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import BootstrapVue, { IconsPlugin } from 'bootstrap-vue';
import ToggleSwitch from 'vuejs-toggle-switch';
import VueSweetalert2 from 'vue-sweetalert2';
import Multiselect from 'vue-multiselect';

import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSweetalert2);
Vue.use(ToggleSwitch);
Vue.component('multiSelect', Multiselect);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
